import React, { useState } from 'react';
import { SupervisorQueueCallPopover } from './SupervisorQueueCallPopover';
import SimplePopover from 'flow/components/ui-components/SimplePopover';

interface Props {
    queueCallKey: string;
    position: number;
    queueName: string;
}

const SupervisorBarQueueItem = ({
    queueCallKey,
    position,
    queueName,
}: Props) => {
    const [isHovered, setIsHovered] = useState(false);
    const [referenceElement, setReferenceElement] = useState<any>();

    return (
        <div className="flex h-3 w-2 hover:h-4 hover:w-3">
            <div
                className="bg-yellow relative flex w-full rounded-xs"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                ref={setReferenceElement}
            />
            {isHovered ? (
                <SimplePopover
                    referenceElement={referenceElement}
                    placement="bottom"
                >
                    <SupervisorQueueCallPopover
                        queueCallKey={queueCallKey}
                        position={position}
                        queueName={queueName}
                    />
                </SimplePopover>
            ) : null}
        </div>
    );
};

export default React.memo(SupervisorBarQueueItem);
